module.exports = __webpack_public_path__ + "img/height_armhole.c5c7d5ba.png";